// src/components/AdminPanel.js
import React, { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { db } from '../firebase';
import {
    collection,
    query,
    where,
    getDocs,
    doc,
    updateDoc,
    serverTimestamp,
    increment,
    onSnapshot
} from 'firebase/firestore';

export default function AdminPanel() {
    const { t } = useLanguage();
    const [pendingPayments, setPendingPayments] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // Real-time listener for pending payments
        const q = query(collection(db, 'pendingPayments'), where('approved', '==', false));

        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const payments = [];
            querySnapshot.forEach((doc) => {
                payments.push({ id: doc.id, ...doc.data() });
            });
            setPendingPayments(payments.sort((a, b) => b.createdAt - a.createdAt));
        });

        return unsubscribe;
    }, []);

    const approvePayment = async (paymentId, userId, amount) => {
        setLoading(true);

        try {
            // Update payment status
            await updateDoc(doc(db, 'pendingPayments', paymentId), {
                approved: true,
                approvedAt: serverTimestamp()
            });

            // Add attempts to user
            await updateDoc(doc(db, 'users', userId), {
                bonusAttempts: increment(amount)
            });

            //alert(`Uplata odobrena! Korisniku dodato ${amount} pokušaja.`);
        } catch (error) {
            console.error("Error approving payment:", error);
            alert("Greška pri odobravanju uplate.");
        } finally {
            setLoading(false);
        }
    };

    if (pendingPayments.length === 0) {
        return null;
    }

    return (
        <div className="fixed bottom-4 right-4 bg-white p-4 rounded-lg shadow-lg max-w-md max-h-96 overflow-y-auto">
            <h3 className="text-lg font-bold mb-4 text-gray-800">{t('admin')}</h3>
            <h4 className="font-semibold mb-2 text-gray-700">{t('pendingPayments')} ({pendingPayments.length}):</h4>

            <div className="space-y-3">
                {pendingPayments.map((payment) => (
                    <div key={payment.id} className="p-3 border rounded bg-gray-50">
                        <p className="text-sm text-gray-600">Email: {payment.userEmail}</p>
                        <p className="text-sm text-gray-600 font-mono font-bold">Kod: {payment.code}</p>
                        <p className="text-sm text-gray-600">Pokušaji: {payment.amount}</p>
                        <p className="text-sm text-gray-600">Cena: {payment.price} RSD</p>
                        <p className="text-xs text-gray-500">
                            Vreme: {payment.createdAt?.toDate?.()?.toLocaleString('sr-RS') || 'N/A'}
                        </p>

                        <button
                            onClick={() => approvePayment(payment.id, payment.userId, payment.amount)}
                            className="mt-2 px-3 py-1 bg-green-500 text-white rounded text-sm hover:bg-green-600 transition-colors disabled:bg-gray-400"
                            disabled={loading}
                        >
                            {t('approvePayment')}
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
}